import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Search, Bookmark, GitCompareArrows, LogOut, Home as HomeIcon, Menu, X, Target } from "lucide-react";

const NAV = [
  { to: "/recruiter", label: "Search Players", icon: Search, end: true, testid: "recruiter-nav-search" },
  { to: "/recruiter/watchlists", label: "Watch Lists", icon: Bookmark, testid: "recruiter-nav-watchlists" },
  { to: "/recruiter/compare", label: "Compare", icon: GitCompareArrows, testid: "recruiter-nav-compare" },
];

export default function RecruiterLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const handleLogout = async () => { await logout(); navigate("/"); };

  return (
    <div className="min-h-screen bg-[#F1F3F5]">
      <div className="lg:hidden sticky top-0 z-30 flex items-center justify-between bg-[#0A192F] text-white px-4 py-3">
        <div className="flex items-center gap-2"><Target className="w-5 h-5 text-[#E63946]" /><span className="font-display text-sm uppercase tracking-tight">Recruiter Portal</span></div>
        <button data-testid="recruiter-mobile-menu" onClick={() => setOpen(true)} className="p-2 -mr-2"><Menu className="w-6 h-6" /></button>
      </div>
      {open && <div className="lg:hidden fixed inset-0 bg-black/50 z-40" onClick={() => setOpen(false)} />}
      <aside className={`w-64 bg-[#0A192F] text-white flex flex-col fixed h-screen z-50 transition-transform duration-200 lg:translate-x-0 ${open ? "translate-x-0" : "-translate-x-full"}`}>
        <div className="px-6 py-6 border-b border-white/10 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img src="/cbr-logo.png" alt="CBR Prospects" className="h-7 w-auto" />
            <div className="border-l border-white/20 pl-2"><div className="font-display text-sm uppercase tracking-tight">Recruiter Portal</div><div className="label-overline text-white/40 text-[9px]">CBR Prospects</div></div>
          </div>
          <button onClick={() => setOpen(false)} className="lg:hidden p-1 text-white/60"><X className="w-5 h-5" /></button>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={n.testid} onClick={() => setOpen(false)}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-sm font-semibold uppercase tracking-wider rounded-sm ${isActive ? "bg-[#E63946] text-white" : "text-white/70 hover:bg-white/5 hover:text-white"}`}>
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-3 py-4 border-t border-white/10">
          <div className="px-3 py-2"><div className="label-overline text-white/40">Signed in</div><div className="text-sm font-semibold mt-1 truncate">{user?.email}</div><div className="text-[10px] text-white/50 uppercase tracking-wider mt-0.5">Recruiter</div></div>
          <NavLink to="/" className="flex items-center gap-2 px-3 py-2 text-xs uppercase tracking-wider text-white/60 hover:text-white"><HomeIcon className="w-4 h-4" /> Public Site</NavLink>
          <button data-testid="recruiter-logout" onClick={handleLogout} className="flex items-center gap-2 px-3 py-2 text-xs uppercase tracking-wider text-[#E63946] hover:text-white w-full text-left"><LogOut className="w-4 h-4" /> Sign Out</button>
        </div>
      </aside>
      <main className="lg:ml-64 min-h-screen">{children}</main>
    </div>
  );
}
